<div class="selection">
  <rask-selector
    aid="inputSelectedMottagningsplats"
    [(ngModel)]="selectedMottagningsplats"
    label="{{'KUNDORDER_DETAIL_MOTTAGNINGSPLATS' | translate}}"
    [required]="true"
    class="col-lg-6"
    [search]="search"
    (change)="mottagningsplatsChange()"
    [viewFormatter]="mottagningsplatsViewFormatter"
    [itemDisabled]="mottagningsplatsDisabled"
    [raskDisabledControl]="readonly">
  </rask-selector>
  <rask-selector
    aid="inputSelectedLagerplats"
    label="{{'KUNDORDER_DETAIL_AVLASTNINGSPLATS' | translate}}"
    [viewFormatter]="lagerplatserViewFormatter"
    class="col-lg-3"
    [(ngModel)]="selectedLagerplats"
    [values]="lagerplatser"
    [raskDisabledControl]="readonly">
  </rask-selector>
  <rask-button aid="buttonLaggTillAm" class="col-lg-1" [disabled]="!canAdd() || !canEdit()" color="primary"
    (click)="add()">
  {{'KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER_LAGG_TILL' | translate }}</rask-button>
</div>

@if (alternativaMottagningsplatser.length === 0) {
  <div>
    <hr />
    <p style="text-align:center">{{'KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER_INGA_TILLAGDA' | translate }} </p>
  </div>
}

@if (alternativaMottagningsplatser.length !== 0) {
  <ul>
    <rask-list [data]="alternativaMottagningsplatser">
      <rask-list-column header="Mottagningsplats" field="mottagningsplats"></rask-list-column>
      <rask-list-column header="Avlastningsplats" field="">
        <ng-template let-row="row">
          {{row.lagerplats?.kod || row.lagerplats?.avlamningsplats}}
        </ng-template>
      </rask-list-column>
      <rask-list-column header="" field="">
        <ng-template let-row="row">
          <rask-icon-button (click)="delete(row)" color="tertiary" icon="far fa-trash-alt" negative
          [disabled]="!canEdit()"></rask-icon-button>
        </ng-template>
      </rask-list-column>
    </rask-list>
  </ul>
}
